import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import translate from "src/i18n/translate";
import { formatNumber, getPercentage } from "../../../src/static/js/commons";
import WidgetLoader from "../common/elements/WidgetLoader";
import ApiError from "../common/elements/ApiError";
export default function TermPersistenceRisk(_a) {
    var highRiskTermPersistence = _a.highRiskTermPersistence, mediumRiskTermPersistence = _a.mediumRiskTermPersistence, lowRiskTermPersistence = _a.lowRiskTermPersistence, notIndicatedRiskTermPersistence = _a.notIndicatedRiskTermPersistence, highRiskTermPersistenceEngagement = _a.highRiskTermPersistenceEngagement, lowRiskTermPersistenceEngagement = _a.lowRiskTermPersistenceEngagement, mediumRiskTermPersistenceEngagement = _a.mediumRiskTermPersistenceEngagement, notIndicatedRiskTermPersistenceEngagement = _a.notIndicatedRiskTermPersistenceEngagement, loader = _a.loader, termSummaryFailed = _a.termSummaryFailed;
    var _b = useState(false), lowRiskTermPopoverState = _b[0], setLowRiskPopoverState = _b[1];
    var _c = useState(false), mediumRiskTermPopoverState = _c[0], setMediumRiskPopoverState = _c[1];
    var _d = useState(false), highRiskTermPopoverState = _d[0], setHighRiskPopoverState = _d[1];
    var _e = useState(false), notIndicatedTermPopoverState = _e[0], setNotIndicatedPopoverState = _e[1];
    var arrOfRiskBarVal = [
        Number(lowRiskTermPersistenceEngagement),
        Number(mediumRiskTermPersistenceEngagement),
        Number(highRiskTermPersistenceEngagement),
        Number(notIndicatedRiskTermPersistenceEngagement)
    ];
    var largestTermPersistenceRiskValue = Math.max.apply(Math, arrOfRiskBarVal);
    var lowRiskCourseEnga = getPercentage(lowRiskTermPersistenceEngagement, largestTermPersistenceRiskValue);
    var mediumRiskCourseEnga = getPercentage(mediumRiskTermPersistenceEngagement, largestTermPersistenceRiskValue);
    var highRiskCourseEnga = getPercentage(highRiskTermPersistenceEngagement, largestTermPersistenceRiskValue);
    var notIndicatedRiskCourseEnga = getPercentage(notIndicatedRiskTermPersistenceEngagement, largestTermPersistenceRiskValue);
    useEffect(function () {
        var lowRiskBtn = document.getElementById("low-risk-term");
        lowRiskBtn === null || lowRiskBtn === void 0 ? void 0 : lowRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === lowRiskBtn) {
                setLowRiskPopoverState(!lowRiskTermPopoverState);
            }
        });
    }, [lowRiskTermPopoverState]);
    useEffect(function () {
        var mediumRiskBtn = document.getElementById("medium-risk-term");
        mediumRiskBtn === null || mediumRiskBtn === void 0 ? void 0 : mediumRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === mediumRiskBtn) {
                setMediumRiskPopoverState(!mediumRiskTermPopoverState);
            }
        });
    }, [mediumRiskTermPopoverState]);
    useEffect(function () {
        var highRiskBtn = document.getElementById("high-risk-term");
        highRiskBtn === null || highRiskBtn === void 0 ? void 0 : highRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === highRiskBtn) {
                setHighRiskPopoverState(!highRiskTermPopoverState);
            }
        });
    }, [highRiskTermPopoverState]);
    useEffect(function () {
        var notIndicatedBtn = document.getElementById("not-indicated-term");
        notIndicatedBtn === null || notIndicatedBtn === void 0 ? void 0 : notIndicatedBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === notIndicatedBtn) {
                setNotIndicatedPopoverState(!notIndicatedTermPopoverState);
            }
        });
    }, [notIndicatedTermPopoverState]);
    function useClosePopoverOutsideClick(ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLowRiskPopoverState(false);
                    setHighRiskPopoverState(false);
                    setMediumRiskPopoverState(false);
                    setNotIndicatedPopoverState(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    var riskSummaryLabel = useIntl().formatMessage({
        id: "app.sse.TermPersistenceriskSummaryLabel"
    });
    var lowRiskLabel = useIntl().formatMessage({
        id: "app.sse.lowRiskLabel"
    });
    var mediumRiskLabel = useIntl().formatMessage({
        id: "app.sse.mediumRiskLabel"
    });
    var highRiskLabel = useIntl().formatMessage({
        id: "app.sse.highRiskLabel"
    });
    var notIndicatedLabel = useIntl().formatMessage({
        id: "app.sse.notIndicatedLabel"
    });
    var riskSummaryLowRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryTermLowRiskText"
    });
    var riskSummaryMediumRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryTermMediumRiskText"
    });
    var riskSummaryHighRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryTermHighRiskText"
    });
    var riskSummaryNotIndicatedText = useIntl().formatMessage({
        id: "app.sse.riskSummaryTermNotIndicatedText"
    });
    var keyEngagementRiskLevel = useIntl().formatMessage({
        id: "app.sse.keyEngagementRiskLevel"
    });
    var notIndicatedPopover = useIntl().formatMessage({
        id: "app.sse.notIndicatedPopover"
    });
    var highRiskPopover = useIntl().formatMessage({
        id: "app.sse.highRiskPopover"
    });
    var mediumRiskPopover = useIntl().formatMessage({
        id: "app.sse.mediumRiskPopover"
    });
    var lowRiskPopover = useIntl().formatMessage({
        id: "app.sse.lowRiskPopover"
    });
    var wrapperRef = useRef(null);
    useClosePopoverOutsideClick(wrapperRef);
    var TermPersistenceRiskBody = function () {
        return (_jsx("div", { className: "body", children: _jsx("div", { className: "wm-grid", children: _jsxs("div", { className: "course-completion-conatiner wm-grid-row", children: [_jsxs("div", { id: "risk-summary-term", className: "risk-summary wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8", children: [_jsx("div", { className: "risk-summary-label", children: translate("app.sse.termPersistenceLabel") }), _jsxs(WmChart, { id: "risk-summary-chart-term", chartType: "doughnut2", label: riskSummaryLabel, valueFormat: "amount", className: "risk-summary-chart", "print-mode": true, children: [_jsx(WmChartSlice, { amount: String(lowRiskTermPersistence), legend: lowRiskLabel, popoverTitle: formatNumber(lowRiskTermPersistence), popoverText: riskSummaryLowRiskText }), _jsx(WmChartSlice, { amount: String(mediumRiskTermPersistence), legend: mediumRiskLabel, popoverTitle: formatNumber(mediumRiskTermPersistence), popoverText: riskSummaryMediumRiskText }), _jsx(WmChartSlice, { amount: String(highRiskTermPersistence), legend: highRiskLabel, popoverTitle: formatNumber(highRiskTermPersistence), popoverText: riskSummaryHighRiskText }), _jsx(WmChartSlice, { amount: String(notIndicatedRiskTermPersistence), legend: notIndicatedLabel, popoverTitle: formatNumber(notIndicatedRiskTermPersistence), popoverText: riskSummaryNotIndicatedText })] }, "risk-summary-char-term")] }), _jsx("div", { id: "key-engagement-term", className: "key-engagement wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8", children: _jsxs(WmChart, { chartType: "bar7", label: keyEngagementRiskLevel, showLegend: false, showBarLegend: true, labelWidth: "95px", valueFormat: "percentage", "print-mode": true, children: [_jsx(WmChartSlice, { amount: formatNumber(lowRiskCourseEnga), legend: lowRiskLabel, popoverTitle: formatNumber(lowRiskTermPersistenceEngagement), popoverText: lowRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(mediumRiskCourseEnga), legend: mediumRiskLabel, popoverTitle: formatNumber(mediumRiskTermPersistenceEngagement), popoverText: mediumRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(highRiskCourseEnga), legend: highRiskLabel, popoverTitle: formatNumber(highRiskTermPersistenceEngagement), popoverText: highRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(notIndicatedRiskCourseEnga), legend: notIndicatedLabel, popoverTitle: formatNumber(notIndicatedRiskTermPersistenceEngagement), popoverText: notIndicatedPopover })] }, "term-persistence-engagment-chart") })] }) }) }));
    };
    return (_jsx("div", { className: "wm-grid-col-12", children: _jsxs("div", { className: "paper-card paper-card-height", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: "title", children: translate("app.sse.termPersistenceRiskTitle") }), _jsx("p", { className: "description -descs", children: translate("app.sse.understandTheTerms") })] }) }), loader && (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })), !loader && !termSummaryFailed && _jsx(TermPersistenceRiskBody, {}), termSummaryFailed && _jsx(ApiError, {})] }) }));
}
